import { jsxs, jsx } from "react/jsx-runtime";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
const DealerInfoSite = ({ label, value, href = value, onClick, className }) => {
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-dealer-info-site", className), children: [
    /* @__PURE__ */ jsxs(Typography.Text, { level: "small", color: "dark-light", className: classnames("perxis-auto-dealer-info-site__label"), children: [
      label,
      ":"
    ] }),
    /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-site__container"), children: /* @__PURE__ */ jsx(
      Button,
      {
        className: classnames("perxis-auto-dealer-info-site__value"),
        type: "link",
        href,
        target: "_blank",
        rel: "noopener",
        icon: /* @__PURE__ */ jsx(Icon, { name: "forward", className: classnames("perxis-auto-dealer-info-site__icon") }),
        iconPosition: "right",
        iconGapSize: "normal",
        onClick,
        children: value
      }
    ) })
  ] });
};
export {
  DealerInfoSite as default
};
//# sourceMappingURL=DealerInfoSite.js.map
